import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Divider, LinearProgress } from '@mui/material';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../hooks/useAppSelector';
import * as parentOrganizationSlice from '../../../data/parent-organizations.slice';
import { useParams } from 'react-router-dom';
import ParentOrganizationHeader from './ParentOrganizationHeader';
import ParentOrganizationDetails from './ParentOrganizationDetails';

const PREFIX = 'Client';

const classes = {
  container: `${PREFIX}-container`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
}));

export default function ParentOrganization() {
  const dispatch = useAppDispatch();
  const params = useParams<{ id: string }>();
  const organization = useAppSelector(
    parentOrganizationSlice.selectCurrentOrganization,
  );
  const loadingOrganization = useAppSelector(
    parentOrganizationSlice.selectLoadingCurrentOrganization,
  );

  React.useEffect(() => {
    if (params.id) {
      dispatch(parentOrganizationSlice.fetchOrganizationAsync(params.id));
    }
  }, [params, dispatch]);

  return (
    <StyledBox className={classes.container}>
      {loadingOrganization && <LinearProgress color="primary" />}
      {!loadingOrganization && (
        <ParentOrganizationHeader
          name={organization?.parentOrganizationName || ''}
        />
      )}
      <Divider />
      {/* <ClientDetails client={client || undefined} readonly={false} /> */}
      <ParentOrganizationDetails organization={organization} />
    </StyledBox>
  );
}
